import Button from "../../design-system/primitives/components/Button/Button";
import Toast from "../../design-system/primitives/components/Toast/Toast";
import type { FeedbackFormDto } from "../../api/feedback";

type Props = {
  form: Extract<FeedbackFormDto, { mode: "link" }>;
  onDismiss: () => void;
  onFollow: () => void;
};

/**
 * A feedback form in `link` mode: title, optional message and a single button to
 * an external page — a survey hosted elsewhere, say. Following the button is the
 * answer, any close a dismissal; the API records either, so the form never comes
 * back for this user.
 */
export const FeedbackLinkToast = ({ form, onDismiss, onFollow }: Props) => {
  return (
    <Toast
      open
      onOpenChange={(open) => {
        if (!open) onDismiss();
      }}
      icon="message-square-share"
      title={form.title}
      description={form.message ?? undefined}
      closeLabel="Schließen"
      // Feedback is never dismissed by a timer — the user decides.
      duration={Infinity}
      actions={
        <Button
          title={form.buttonLabel}
          color="accent"
          variant="secondary"
          size="small"
          iconRight="arrow-up-right"
          // A new tab, so the spark stays where the user left it. `onFollow`
          // unmounts the toast, which doesn't stop the click: a detached `<a>`
          // still follows its link.
          href={form.buttonLink}
          target="_blank"
          onClick={onFollow}
        />
      }
    />
  );
};
